"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _SearchPanel = require("./SearchPanel.style");
var _SearchBox = _interopRequireDefault(require("../../../SearchBox"));
var _Text = _interopRequireDefault(require("../../../Text"));
const SearchPanel = _ref => {
  let {
    onClose,
    setInputRef,
    isShowing
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SearchPanel.SearchWrapper, {
    isShowing: isShowing
  }, /*#__PURE__*/_react.default.createElement(_SearchBox.default, {
    setInputRef: setInputRef,
    tallerInput: true,
    onSearched: onClose,
    clearOnSearch: true
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    variant: "Secondary",
    size: "Small",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    intlText: "General.Cancel"
  })));
};
var _default = exports.default = SearchPanel;